// getSearchParams.js
'use strict';

/**
 * Get search params
 * @param {string} queryKey - search params key
 */
export const getSearchParams = ({ queryKey }) => {
  if (typeof window === 'undefined' && !queryKey) return '';

  let params = {};
  decodeURIComponent(window.location.search)
    .replace(/^\?/g, '')
    .split('&')
    .forEach(paramStr => {
      const param = paramStr?.split('=');
      params[param[0]] = params[param[0]] || param[1];
    });
  return params?.[queryKey];
};

export default getSearchParams;
